module.exports = __webpack_public_path__ + "static/media/exp.32311a9c.png";